import React from "react";

type Height = "sm" | "md" | "lg" | "xl";
type Width = "full" | "half" | "small";

interface ICQStencilsStickProps {
  className?: string;
  height?: Height;
  width?: Width;
  shade?: boolean;
  style?: React.CSSProperties;
}

const Heights: Record<Height, string> = {
  xl: "2rem",
  lg: "1rem",
  md: "0.6rem",
  sm: "0.2rem",
};

const Widths: Record<Width, string> = {
  full: "100%",
  half: "50%",
  small: "30%",
};

export default function CQStencilsStick({
  className,
  height = "sm",
  width = "full",
  shade = true,
  style,
}: ICQStencilsStickProps) {
  const cStyle: React.CSSProperties = {
    padding: Heights[height],
    width: Widths[width],
    ...style,
  };

  return (
    <p
      style={cStyle}
      className={`slds-box ${
        shade ? "slds-theme_shade" : "slds-theme_default"
      } ${className}`}
    ></p>
  );
}
